module.exports = __webpack_public_path__ + "static/media/token-logo.85bd2c7c.png";